import { Component } from '@angular/core'

@Component({
  selector: 'se-po-feature-profile-side-panel-docs',
  templateUrl: './feature-profile-side-panel-docs.component.html',
  styleUrls: ['./feature-profile-side-panel-docs.component.scss'],
  standalone: false,
})
export class FeatureProfileSidePanelDocsComponent {}
